import { useNavigate } from 'react-router';

import { User02Icon } from '@/assets/icons';
import { InlineTabs, InlineTabsList, InlineTabsTrigger, TabsContent } from '@/components/common';

import { TabViewMode } from '@/features/user-management/enums';

import { AuditLog } from './AuditLog';
import { UserList } from './UserList';

const UserManagementList = () => {
  const currentTab = location.hash.replace('#', '') || TabViewMode.UserList;
  const navigate = useNavigate();

  return (
    <div className="flex flex-col justify-start items-center gap-6">
      <div className="w-full flex flex-row justify-start items-center">
        <div className="flex flex-col justify-start items-start gap-3">
          <div className="flex flex-row justify-start items-center gap-3">
            <User02Icon className="size-8 text-neutral-6" />
            <span className="font-bold text-display text-neutral-9">User Management</span>
          </div>
          <span className="font-medium text-body-base text-neutral-7">
            User Accounts Overview & Permissions
          </span>
        </div>
      </div>
      <div className="w-full">
        <InlineTabs
          value={currentTab}
          onValueChange={(value) => {
            navigate({ hash: value }, { replace: true });
          }}
          className="w-full !gap-0"
        >
          <InlineTabsList className="w-full !gap-0">
            <InlineTabsTrigger value={TabViewMode.UserList} className="w-[200px] !py-0 mb-4">
              User List
            </InlineTabsTrigger>
            <InlineTabsTrigger value={TabViewMode.AuditLog} className="w-[200px] !py-0 mb-4">
              Audit Log
            </InlineTabsTrigger>
          </InlineTabsList>
          <TabsContent value={TabViewMode.UserList} className="mt-4">
            <UserList />
          </TabsContent>
          <TabsContent value={TabViewMode.AuditLog} className="mt-4">
            <AuditLog />
          </TabsContent>
        </InlineTabs>
      </div>
    </div>
  );
};

export default UserManagementList;
